'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var ipfsUnixfsImporter = require('ipfs-unixfs-importer');

var normaliseInputMultiple = require('ipfs-core-utils/files/normalise-input-multiple');

var utils = require('./utils.js');

var itPipe = require('it-pipe');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var mergeOpts = require('merge-options');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var mergeOpts__default = /*#__PURE__*/_interopDefaultLegacy(mergeOpts);

var mergeOptions = mergeOpts__default["default"].bind({
  ignoreUndefined: true
});

function createAddAll(_ref) {
  var repo = _ref.repo,
      preload = _ref.preload,
      options = _ref.options;
  var isShardingEnabled = options && options.sharding;

  function addAll(_x) {
    return _addAll.apply(this, arguments);
  }

  function _addAll() {
    _addAll = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
      var options,
          opts,
          totals,
          prog,
          iterator,
          releaseLock,
          _iteratorAbruptCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          added,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              opts = mergeOptions({
                shardSplitThreshold: isShardingEnabled ? 1000 : Infinity,
                strategy: 'balanced'
              }, options, _objectSpread({}, utils.parseChunkerString(options.chunker)));

              if (opts.hashAlg && opts.hashAlg !== 'sha2-256' && opts.cidVersion !== 1) {
                opts.cidVersion = 1;
              }

              if (opts.trickle) {
                opts.strategy = 'trickle';
              }

              if (opts.strategy === 'trickle') {
                opts.leafType = 'raw';
                opts.reduceSingleLeafToSelf = false;
              }

              if (opts.cidVersion > 0 && opts.rawLeaves === undefined) {
                opts.rawLeaves = true;
              }

              if (opts.hashAlg !== undefined && opts.rawLeaves === undefined) {
                opts.rawLeaves = true;
              }

              delete opts.trickle;
              totals = {};

              if (opts.progress) {
                prog = opts.progress;

                opts.progress = function (bytes, path) {
                  if (!totals[path]) {
                    totals[path] = 0;
                  }

                  totals[path] += bytes;
                  prog(totals[path], path);
                };
              }

              iterator = itPipe.pipe(normaliseInputMultiple.normaliseInput(source), function (source) {
                return ipfsUnixfsImporter.importer(source, repo.blocks, _objectSpread(_objectSpread({}, opts), {}, {
                  pin: false
                }));
              }, transformFile(opts), preloadFile(preload, opts), pinFile(repo, opts));
              _context.next = 13;
              return _awaitAsyncGenerator(repo.gcLock.readLock());

            case 13:
              releaseLock = _context.sent;
              _context.prev = 14;
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context.prev = 17;
              _iterator = _asyncIterator(iterator);

            case 19:
              _context.next = 21;
              return _awaitAsyncGenerator(_iterator.next());

            case 21:
              if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                _context.next = 29;
                break;
              }

              added = _step.value;
              delete totals[added.path];
              _context.next = 26;
              return added;

            case 26:
              _iteratorAbruptCompletion = false;
              _context.next = 19;
              break;

            case 29:
              _context.next = 35;
              break;

            case 31:
              _context.prev = 31;
              _context.t0 = _context["catch"](17);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 35:
              _context.prev = 35;
              _context.prev = 36;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context.next = 40;
                break;
              }

              _context.next = 40;
              return _awaitAsyncGenerator(_iterator.return());

            case 40:
              _context.prev = 40;

              if (!_didIteratorError) {
                _context.next = 43;
                break;
              }

              throw _iteratorError;

            case 43:
              return _context.finish(40);

            case 44:
              return _context.finish(35);

            case 45:
              _context.prev = 45;
              releaseLock();
              return _context.finish(45);

            case 48:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[14,, 45, 48], [17, 31, 35, 45], [36,, 40, 44]]);
    }));
    return _addAll.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(addAll);
}

function transformFile(opts) {
  function transformFile(_x2) {
    return _transformFile.apply(this, arguments);
  }

  function _transformFile() {
    _transformFile = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source) {
      var _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, file, cid, path;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorAbruptCompletion2 = false;
              _didIteratorError2 = false;
              _context2.prev = 2;
              _iterator2 = _asyncIterator(source);

            case 4:
              _context2.next = 6;
              return _awaitAsyncGenerator(_iterator2.next());

            case 6:
              if (!(_iteratorAbruptCompletion2 = !(_step2 = _context2.sent).done)) {
                _context2.next = 17;
                break;
              }

              file = _step2.value;
              cid = file.cid;

              if (opts.cidVersion === 1) {
                cid = cid.toV1();
              }

              path = file.path ? file.path : cid.toString();

              if (opts.wrapWithDirectory && !file.path) {
                path = '';
              }

              _context2.next = 14;
              return {
                path: path,
                cid: cid,
                size: file.size,
                mode: file.unixfs && file.unixfs.mode,
                mtime: file.unixfs && file.unixfs.mtime
              };

            case 14:
              _iteratorAbruptCompletion2 = false;
              _context2.next = 4;
              break;

            case 17:
              _context2.next = 23;
              break;

            case 19:
              _context2.prev = 19;
              _context2.t0 = _context2["catch"](2);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 23:
              _context2.prev = 23;
              _context2.prev = 24;

              if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                _context2.next = 28;
                break;
              }

              _context2.next = 28;
              return _awaitAsyncGenerator(_iterator2.return());

            case 28:
              _context2.prev = 28;

              if (!_didIteratorError2) {
                _context2.next = 31;
                break;
              }

              throw _iteratorError2;

            case 31:
              return _context2.finish(28);

            case 32:
              return _context2.finish(23);

            case 33:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 19, 23, 33], [24,, 28, 32]]);
    }));
    return _transformFile.apply(this, arguments);
  }

  return transformFile;
}

function preloadFile(preload, opts) {
  function maybePreloadFile(_x3) {
    return _maybePreloadFile.apply(this, arguments);
  }

  function _maybePreloadFile() {
    _maybePreloadFile = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(source) {
      var _iteratorAbruptCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, file, isRootFile, shouldPreload;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _iteratorAbruptCompletion3 = false;
              _didIteratorError3 = false;
              _context3.prev = 2;
              _iterator3 = _asyncIterator(source);

            case 4:
              _context3.next = 6;
              return _awaitAsyncGenerator(_iterator3.next());

            case 6:
              if (!(_iteratorAbruptCompletion3 = !(_step3 = _context3.sent).done)) {
                _context3.next = 16;
                break;
              }

              file = _step3.value;
              isRootFile = !file.path || opts.wrapWithDirectory ? file.path === '' : !file.path.includes('/');
              shouldPreload = isRootFile && !opts.onlyHash && opts.preload !== false;

              if (shouldPreload) {
                preload(file.cid);
              }

              _context3.next = 13;
              return file;

            case 13:
              _iteratorAbruptCompletion3 = false;
              _context3.next = 4;
              break;

            case 16:
              _context3.next = 22;
              break;

            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](2);
              _didIteratorError3 = true;
              _iteratorError3 = _context3.t0;

            case 22:
              _context3.prev = 22;
              _context3.prev = 23;

              if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
                _context3.next = 27;
                break;
              }

              _context3.next = 27;
              return _awaitAsyncGenerator(_iterator3.return());

            case 27:
              _context3.prev = 27;

              if (!_didIteratorError3) {
                _context3.next = 30;
                break;
              }

              throw _iteratorError3;

            case 30:
              return _context3.finish(27);

            case 31:
              return _context3.finish(22);

            case 32:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 18, 22, 32], [23,, 27, 31]]);
    }));
    return _maybePreloadFile.apply(this, arguments);
  }

  return maybePreloadFile;
}

function pinFile(repo, opts) {
  function maybePinFile(_x4) {
    return _maybePinFile.apply(this, arguments);
  }

  function _maybePinFile() {
    _maybePinFile = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(source) {
      var _iteratorAbruptCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, file, isRootDir, shouldPin;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _iteratorAbruptCompletion4 = false;
              _didIteratorError4 = false;
              _context4.prev = 2;
              _iterator4 = _asyncIterator(source);

            case 4:
              _context4.next = 6;
              return _awaitAsyncGenerator(_iterator4.next());

            case 6:
              if (!(_iteratorAbruptCompletion4 = !(_step4 = _context4.sent).done)) {
                _context4.next = 18;
                break;
              }

              file = _step4.value;
              isRootDir = !(file.path && file.path.includes('/'));
              shouldPin = (opts.pin == null ? true : opts.pin) && isRootDir && !opts.onlyHash;

              if (!shouldPin) {
                _context4.next = 13;
                break;
              }

              _context4.next = 13;
              return _awaitAsyncGenerator(repo.pins.pinRecursively(file.cid));

            case 13:
              _context4.next = 15;
              return file;

            case 15:
              _iteratorAbruptCompletion4 = false;
              _context4.next = 4;
              break;

            case 18:
              _context4.next = 24;
              break;

            case 20:
              _context4.prev = 20;
              _context4.t0 = _context4["catch"](2);
              _didIteratorError4 = true;
              _iteratorError4 = _context4.t0;

            case 24:
              _context4.prev = 24;
              _context4.prev = 25;

              if (!(_iteratorAbruptCompletion4 && _iterator4.return != null)) {
                _context4.next = 29;
                break;
              }

              _context4.next = 29;
              return _awaitAsyncGenerator(_iterator4.return());

            case 29:
              _context4.prev = 29;

              if (!_didIteratorError4) {
                _context4.next = 32;
                break;
              }

              throw _iteratorError4;

            case 32:
              return _context4.finish(29);

            case 33:
              return _context4.finish(24);

            case 34:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 20, 24, 34], [25,, 29, 33]]);
    }));
    return _maybePinFile.apply(this, arguments);
  }

  return maybePinFile;
}

exports.createAddAll = createAddAll;